import { CommonMostLikelyMorphologicCodeResponse } from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.dto'
import { ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-most-likely-morphologic-code-assignment/configuration-personnel-most-likely-morphologic-code-assignment.dto'
import { store } from '@/store/store'

export interface ConfigurationAutomationPersonnelEntitiesAssociationModalMostLikelyMorphologicCodeAssignmentFormState {
    mostLikelyMorphologicCodes: CommonMostLikelyMorphologicCodeResponse[]
    personnelMostLikelyMorphologicCodeAssignments: ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentResponse[]
    laboratoryId: number
}
export const initialConfigurationAutomationPersonnelEntitiesAssociationModalMostLikelyMorphologicCodeAssignmentFormState =
    (): ConfigurationAutomationPersonnelEntitiesAssociationModalMostLikelyMorphologicCodeAssignmentFormState => ({
        mostLikelyMorphologicCodes: [],
        personnelMostLikelyMorphologicCodeAssignments: [],
        laboratoryId: store.getters.labId
    })
